module.exports = __webpack_public_path__ + "img/risks-stroke.258a39bc.svg";